import { Calendar } from 'lucide-react';

const PRESETS = [
  { key: 'current_week', label: 'Current Week' },
  { key: 'previous_week', label: 'Previous Week' },
  { key: 'monthly', label: 'Monthly' },
  { key: 'ytd', label: 'YTD' },
];

export default function PeriodFilter({ value = 'current_week', onChange }) {
  return (
    <div className="flex items-center gap-1.5 bg-white border border-slate-200 rounded-xl p-1 text-xs" data-testid="period-filter">
      <Calendar className="w-3.5 h-3.5 text-slate-400 ml-2" />
      {PRESETS.map(p => (
        <button
          key={p.key}
          onClick={() => onChange?.(p.key)}
          aria-pressed={value === p.key}
          className={`px-3 py-1.5 rounded-lg font-medium transition-colors ${
            value === p.key
              ? 'bg-orange-500 text-white shadow-sm'
              : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'
          }`}
          data-testid={`period-${p.key}`}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
